export enum AgreementType {
  PRICE_SUPPORT_AGREEMENT = 'PRICE_SUPPORT_AGREEMENT',
  DISPENSER_AGREEMENT = 'DISPENSER_AGREEMENT'
}

export enum AgreementStatus {
  OFFER = 'BUYER_OFFER',
  SUBMITTED = 'BUYER_SUBMITTED',
  ACCEPTED = 'BUYER_ACCEPTED',
  REJECTED = 'BUYER_REJECTED',
  PENDING = 'AWAITING_DISTRIBUTOR_APPROVAL',
  EXPIRED = 'EXPIRED',
  REVIEWING = 'BUYER_REVIEWING',
  WAITING_SIGNED_AGREMMENT = 'WAITING_SIGNED_AGREMMENT',
  CANCELLED = 'CANCELLED'
}

export enum AgreementStatusDisplay {
  OFFER = 'Offer',
  SUBMITTED = 'Submitted',
  ACCEPTED = 'Accepted',
  REJECTED = 'Rejected',
  PENDING = 'Pending',
  EXPIRED = 'expired',
  CANCELLED = 'Cancelled'
}
export enum ShipmentAgreementHistoryStatus {
  PLACED = 'PLACED',
  CREATED = 'CREATED',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
  CONFIRMED = 'CONFIRMED',
  IN_PROGRESS = 'IN_PROGRESS'
}

export enum ShipmentAgreementDetailStatus {
  PLACED = 'PLACED',
  COMPLETED = 'COMPLETED',
  DELIVERED = 'DELIVERED',
  BACK_ORDERED = 'BACK_ORDERED',
  CONFIRMED = 'CONFIRMED',
  CANCELLED = 'CANCELLED',
  CANCELLING = 'CANCELLING',
  PARTIALLY_DELIVERED = 'PARTIALLY_DELIVERED'
}
